<template>
  <v-combobox :ref="inputRef"
              v-model="fieldValue"
              :hint="field.hint"
              :persistent-hint="true"
              :disabled="field.disabled"
              :label="label"
              :class="field.class"
              :rules="validationRules"
              multiple
              append-icon=""
              clearable
              @input="fieldChanged">
    <template #selection="data">
      <v-chip :value="data.selected" close @input="removeChip(data.item)">
        <strong>{{ data.item }}</strong>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
import { defineComponent, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'

export default defineComponent({
  name: 'DynamicChips',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      label,
      fieldChanged,
      inputRef,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: [],
      emit
    })

    const removeChip = (item) => {
      fieldValue.value.splice(fieldValue.value.indexOf(item), 1)
      fieldValue.value = [...fieldValue.value]
      emit('input', fieldValue.value)
    }

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      label,
      fieldChanged,
      removeChip,
      inputRef
    }
  }
})
</script>

<style lang="scss">
</style>